module.exports = __webpack_public_path__ + "static/media/hero.0732ba30.jpg";